module.exports = __webpack_public_path__ + "img/Group1.81f6c4cc.svg";